/**
 * 放一些公用的组件
 */
santakButton
import Breadcrumb from './Breadcrumb.vue'
import santakButton from './santakButton.vue'
import optionSelect from './optionSelect.vue'
import santakinput from './santakInput.vue'
import splitLine from './splitLine.vue'
const components = [];
components.push(Breadcrumb,santakButton,optionSelect,santakinput,splitLine);

var install = (Vue)=>{
    components.forEach((component)=>{
        Vue.component(component.name,component)
    })
}
export default install;